// extracted by mini-css-extract-plugin
export default {"totalPrice":"Basket_totalPrice__mgbfM","buttonGroup":"Basket_buttonGroup__hnArk"};